import { render, staticRenderFns } from "./TheFooterIndex.vue?vue&type=template&id=ee3670c2&"
import script from "./TheFooterIndex.vue?vue&type=script&lang=js&"
export * from "./TheFooterIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports